var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingAtAuditor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8311 31.159H5.68561V3.09375H20.1638L27.2688 10.2067V21.4438H25.1081V11.0978L19.2648 5.25444H7.83841V29.0062H18.8311V31.159Z",
    fill: "#AA78B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1885 11.7274H18.634V4.17285H20.7947V9.57457H26.1885V11.7274Z",
    fill: "#AA78B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1815 34.6999L17.3249 28.9827L28.2229 18.0847C29.4452 16.8624 31.5744 16.8624 32.7967 18.0847C33.4117 18.6919 33.7429 19.5041 33.7429 20.3715C33.7429 21.239 33.4039 22.0512 32.7967 22.6584L21.8986 33.5565L16.1815 34.6999ZM19.3121 30.0394L18.9336 31.9399L20.834 31.5614L31.2747 21.1207C31.4797 20.9157 31.5901 20.6475 31.5901 20.3558C31.5901 20.0719 31.4797 19.7959 31.2747 19.5987C30.8647 19.1887 30.1628 19.1887 29.7528 19.5987L19.3121 30.0394Z",
    fill: "#AA78B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6871 13.8887H10.3223V16.0494H22.6871V13.8887Z",
    fill: "#AA78B4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6871 18.21H10.3223V20.3706H22.6871V18.21Z",
    fill: "#AA78B4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6871 22.5244H10.3223V24.6851H22.6871V22.5244Z",
    fill: "#AA78B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingAtAuditor);
export default __webpack_public_path__ + "static/media/Pending At Auditor.ed6de63d8b3ae55c1520d1e5f2571ba4.svg";
export { ForwardRef as ReactComponent };